import React from 'react';
import PropTypes from 'prop-types';

function StepList({ activeStep, ignore }) {
  if (ignore) return null;
  return (
    <ul className="trial-step-list">
      {[1, 2, 3, 4].map(stepNumber => (
        <li
          className={`trial-step ${
            activeStep === stepNumber ? 'trial-step-active' : ''
          }`}
          key={`step-${stepNumber}`}
        >
          {stepNumber}
        </li>
      ))}
    </ul>
  );
}

StepList.propTypes = {
  activeStep: PropTypes.number.isRequired,
  ignore: PropTypes.bool.isRequired,
};

export default StepList;
